import { TextField, TextFieldProps } from "@mui/material";
import { FieldInputProps, FieldMetaProps, FastField, Field } from "formik";
import { ReactElement } from "react";

export default function FormTextField(props: TextFieldProps): ReactElement {
  return (
    <TextField
      {...(props as TextFieldProps)}
      InputLabelProps={{
        shrink: true,
        ...(props.InputLabelProps || {}),
      }}
      InputProps={{
        ...(props.InputProps || {}),
      }}
    />
  );
}

export function FormikTextField({
  name,
  shouldUpdate,
  fast,
  overrideFormikProps,
  bottomLabel,
  customError,
  ...childProps
}: TextFieldProps & {
  name: string;
  shouldUpdate?: (props: any, prevProps: any) => boolean;
  fast?: boolean;
  overrideFormikProps?: (
    field: FieldInputProps<unknown>,
    meta: FieldMetaProps<unknown>
  ) => FieldInputProps<unknown>;
  bottomLabel?: string;
  customError?: { errorText: string | undefined };
}): ReactElement {
  const Component = fast ? FastField : Field;
  return (
    <Component name={name} shouldUpdate={shouldUpdate}>
      {({
        field,
        meta,
      }: {
        field: FieldInputProps<unknown>;
        meta: FieldMetaProps<unknown>;
      }) => {
        const error = customError ? customError.errorText : meta.error;
        return (
          <FormTextField
            error={meta.touched && Boolean(error)}
            helperText={meta.touched && Boolean(error) ? error : bottomLabel}
            {...(overrideFormikProps
              ? overrideFormikProps(field, meta)
              : field)}
            {...childProps}
          />
        );
      }}
    </Component>
  );
}
